import React from 'react';
import utilSvc from '../../../../../core/utilSvc';
import { lightFormat } from 'date-fns';

import { IraDataItem } from '../../../ira_types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CreatedByRenderer = ({ item, colKey }: { item: IraDataItem; colKey: string }): JSX.Element => {
    return (
        <>
            {item.CreatedBy ? <p className="non-padded-text">{item.CreatedBy}</p> : null}
            {utilSvc.dt.isValid(item.CreatedDate) ? (
                <p className="non-padded-text">{lightFormat(item.CreatedDate, utilSvc.dt.fmtMdyyyy)}</p>
            ) : null}
        </>
    );
};

export default CreatedByRenderer;
